export default class FeaturedAppointmentItemModel {
  static isSelected(time: string, dateStart: string): boolean {
    return Boolean(dateStart) && time === dateStart;
  }
}
